import {where} from "firebase/firestore";
import dayjs from "dayjs";
import weekOfYear from 'dayjs/plugin/weekOfYear'
import 'dayjs/locale/es'
import {obtenerFechasIniFinSemanasAtras} from "./Funciones/obtenerFechasIniFinSemanasAtras";
import {contarWheresSuma} from "../Contadores/contarWheresSuma";


export const arrConteoColSemanasAtrasWhereSuma = async ({coleccion, semanasAtras = 1, wheres = [], propiedad}) => {
    dayjs.locale('es')
    // obtener arr de timestamp inicio mes, fin mes
    let arrFechasInicioFin = obtenerFechasIniFinSemanasAtras(semanasAtras)


    let arrPromesas = []

    for (let i = 0; i < arrFechasInicioFin.length; i++) {
        arrPromesas.push(docmentosFecha(arrFechasInicioFin[i], coleccion, wheres, propiedad))
    }

    let arr = await Promise.all(arrPromesas)
    return arr.reverse()

}

const docmentosFecha = async (fechas, coleccion, ws, propiedad) => {
    dayjs.locale('es')
    dayjs.extend(weekOfYear)

    let wheres = [where('fecha', '>=', fechas.fechaInicio), where('fecha', '<=', fechas.fechaFin), ...ws]
    let result = await contarWheresSuma({coleccion: coleccion, wheres: wheres, propiedad: propiedad})

    return {
        nombre: `Semana ${dayjs(fechas.fechaInicio).week()}`,
        cantidad: result.data
    }

}